module.exports = __webpack_public_path__ + "img/a6_02.48a9522b.jpg";